import type { MedplumClient } from '@medplum/core';
import type { Bundle, CarePlan, PlanDefinition } from '@medplum/fhirtypes';

// Resolve the PlanDefinition a CarePlan instantiates, by its pinned canonical.
// The canonical is `url|version`, so search on BOTH — resolving by url alone
// would accept any version present and could render/seed from the wrong one
// when multiple versions of a template coexist. Shared by the encounter
// read-only view and the patient-profile detail so both pin the same version.
export async function fetchPlanDefinitionForCarePlan(
  client: MedplumClient,
  carePlan: CarePlan,
): Promise<PlanDefinition | undefined> {
  const canonical = carePlan.instantiatesCanonical?.[0];
  if (!canonical) return undefined;

  const [url, version] = canonical.split('|');
  if (!url) return undefined;

  const bundle = (await client.search('PlanDefinition', {
    url,
    ...(version ? { version } : {}),
  })) as Bundle<PlanDefinition>;
  return bundle.entry?.[0]?.resource;
}
